module.exports = __webpack_public_path__ + "static/media/add_participant.25959c3f.png";